import { Component, OnInit, Output, EventEmitter } from '@angular/core';
import { FilterFourService } from '../filter-four/filter-four.service';
import { CommonUtilitiesService } from '../../common-utilities.service';
import { FormGroup, FormBuilder } from '@angular/forms';
import * as inside from 'point-in-polygon';
import calles from './filtroCalles.json';
import { Router } from '@angular/router';


declare const google: any;

@Component({
  selector: 'app-filter-three',
  templateUrl: './filter-three.component.html',
  styleUrls: ['./filter-three.component.scss'],
  providers: [FilterFourService]
})
export class FilterThreeComponent implements OnInit {

  isShowModal = false;
  modalTitle = "";
  modalContent = "";
  isModalReload = false;

  public CARE_CHANNELS_TITLE: string = this.LANG.getLangText("CARE_CHANNELS_FOOTER_TITTLE_GENERIC");
  @Output() dataFilter = new EventEmitter<any>();

  form: FormGroup
  input_principal:any
  input_secondary:any
  autocomplete_principal:any
  autocomplete_secondary:any
  isLoadingBalance = false;
  tecnologies = []

  street = []

  
  constructor(
    public LANG: CommonUtilitiesService,
    private formbuilder:FormBuilder,
    private _router: Router, 
    private filterFourService:FilterFourService
  ) { }

  ngOnInit() {
    this.form = this.formbuilder.group({
      techSelec: [''],
      autocomplete_principal: [''],
      autocomplete_secondary: ['']
    });
    this.get_technology_coverage_list()
  }


  /**
   * Description: Método que llama el servicio web de obtener todas las tecnologiaS
   * Autor: Luis Hernandez
   * @return Tecnologias
   */
  get_technology_coverage_list(){
    this.isLoadingBalance = true;
    this.filterFourService.get_technology_coverage_list().subscribe(technologys => {
      this.tecnologies = technologys["obj"]
      this.isLoadingBalance = false;
    });
  }

  get_autocomplete_principal(event){
  
    this.input_principal = document.getElementById('principalStreet');
    var options = {componentRestrictions: {country: "ec"}};
    this.autocomplete_principal = new google.maps.places.Autocomplete(
      document.getElementById('principalStreet'), options
    );
  }

  get_autocomplete_secondary(event){

    this.input_secondary = document.getElementById('secondaryStreet');
    let options = {componentRestrictions: {country: "ec"}};
    this.autocomplete_secondary = new google.maps.places.Autocomplete(
      document.getElementById('secondaryStreet'), options
    );
  }


  get_street_coverage(){

    this.isLoadingBalance = true;
    if(
        this.form.get('autocomplete_principal').value != "" && 
        this.form.get('autocomplete_secondary').value != "" &&
        this.form.get('techSelec').value != ""){

          let LatLng_principal;
          if(this.autocomplete_principal.getPlace().geometry.location.lat() &&
          this.autocomplete_principal.getPlace().geometry.location.lng()){
            LatLng_principal = new google.maps.LatLng(
              this.autocomplete_principal.getPlace().geometry.location.lat(), 
              this.autocomplete_principal.getPlace().geometry.location.lng()
            )
          } else {
            this.modalTitle = this.LANG.getLangText('PORTABILITY_MODAL_TITLE_VALIDATION');
            this.modalContent = "Ocurrió un error al seleccionar las calles, por favor vuelva a seleccionarlas";
            this.isShowModal = true;
            this.isLoadingBalance = false;
            return;
          }
        
        let circle = new google.maps.Circle({
          center: LatLng_principal,
          radius: 10000
        });

        let LatLng_secondary = new google.maps.LatLng(
          this.autocomplete_secondary.getPlace().geometry.location.lat(), 
          this.autocomplete_secondary.getPlace().geometry.location.lng()
        )

        let x = circle.getBounds().contains(LatLng_secondary);

        if(x){
          this.getKmlLocation()
        }else{
          this.isLoadingBalance = false;
          this.modalTitle = this.LANG.getLangText('PORTABILITY_MODAL_TITLE_VALIDATION');
          this.modalContent = "Las calles no pertenecen a la misma ciudad";
          this.isShowModal = true;
          this.isLoadingBalance = false;
        }

    }else{

      this.modalTitle = this.LANG.getLangText('PORTABILITY_MODAL_TITLE_VALIDATION');
      this.modalContent = this.LANG.getLangText('PORTABILITY_MODAL_CONTENT_VALIDATION');
      this.isShowModal = true;
      this.isLoadingBalance = false;

    }



  }


  getKmlLocation(){

    let regionGet = ""
    const result = calles.filter(calle => calle.tech == this.form.get('techSelec').value);
    for (let el of result[0].data) {
      let itera:any = el
      let dataEvalu = []
      itera.coord.forEach(coord => {
        let coo = coord.split(",");
        dataEvalu.push([parseFloat(coo[1]),parseFloat(coo[0])])
      });

      let searchRegion = inside([
                                  parseFloat(this.autocomplete_principal.getPlace().geometry.location.lat()), 
                                  parseFloat(this.autocomplete_principal.getPlace().geometry.location.lng())
                                ], dataEvalu)
      if(searchRegion){
        regionGet = el.region
        break;
      }
      
    }

    this.street = []
    this.street.push({"filter":3,"data":[],"type":this.form.get('techSelec').value,"coord":{"lat":null,"lng":null}})
    this.street[0].data.push(this.LANG.getLangText('URL_PATH_KML')+regionGet+"/"+this.form.get('techSelec').value+"/predictions.kml")
    this.street[0].coord.lat = this.autocomplete_principal.getPlace().geometry.location.lat()
    this.street[0].coord.lng = this.autocomplete_principal.getPlace().geometry.location.lng()
    this.dataFilter.emit(this.street)
    this.isLoadingBalance = false;
      

  }

  /**
   * Description: Método que ocualta el modal
   * Autor: Luis Hernandez
   * @param N/A
   * @return N/A
   */
  hideModal() {
    this.isShowModal = false;
    if (this.isModalReload) {
      this._router.navigate(['/']);
    } 
  }

}
